import { Typography } from "@/components/atoms";

const Graphic = () => (
  <div className="relative h-[100px] w-[164px]">
    <div className="absolute left-[40px] top-0 size-[52px] -rotate-[15deg] rounded-lg bg-primary opacity-50" />
    <div className="absolute left-[80px] top-[3px] size-[44px] rotate-[30deg] rounded-lg bg-primary opacity-20" />
    <div className="absolute bottom-0 left-1/2 h-14 w-[164px] -translate-x-1/2 overflow-hidden rounded-md border border-neutral-mid-gray bg-white shadow-[0px_4px_12px_-4px_rgba(71,84,103,0.1)]">
      <div className="absolute left-[11px] top-[10px] h-[9px] w-[76px] rounded-full bg-neutral-gray" />
      <div className="absolute left-[11px] top-[30px] h-[9px] w-[95px] rounded-full bg-neutral-gray" />
      <div className="absolute left-[116px] top-[30px] h-[9px] w-[17px] rounded-full bg-neutral-gray" />
    </div>
  </div>
);

export const BookingHistoryEmptyState = () => (
  <section className="flex min-h-[300px] flex-col items-center justify-center p-8 lg:p-16">
    <Graphic />
    <div className="mt-6 text-center">
      <Typography variant="action" className="mb-1 block text-neutral-dark-gray">
        No Bookings
      </Typography>
      <Typography className="max-w-[400px] text-neutral-dark-gray">
        There are currently no bookings available for this month
      </Typography>
    </div>
  </section>
);
